import { render } from "./FooterVue.vue?vue&type=template&id=847a8580"
import script from "./FooterVue.vue?vue&type=script&lang=js"
export * from "./FooterVue.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\DELL\\Desktop\\PROJECTS\\portfolio\\v1\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__